import { useI18n } from '#/i18n/hooks/useI18n';
import type { OrgDashboardApiOrg } from '#/modules/orgDashboard/api/types/OrgDashboardApiOrg';
import {
  orgDashboardCreateEventRoute,
  orgDashboardCreateInternshipRoute,
  orgDashboardCreateJobRoute,
  orgDashboardCreateVolopRoute,
} from '#/modules/orgDashboard/routing/orgDashboard.routes';
import { createInternshipRoute, createJobRoute } from '#/routing/routes';

type Args = {
  org: OrgDashboardApiOrg | undefined;
};

type PostAListingPageButtonData = {
  type: string;
  label: string;
  url: string;
};

export function usePostAListingPageButtons({
  org,
}: Args): PostAListingPageButtonData[] {
  const { i18n } = useI18n();

  if (!org) {
    return [
      {
        type: 'JOB',
        label: i18n('Job'),
        url: createJobRoute.with({}),
      },
      {
        type: 'INTERNSHIP',
        label: i18n('Internship'),
        url: createInternshipRoute.with({}),
      },
    ];
  }

  const orgId = org.id;
  const buttons: PostAListingPageButtonData[] = [
    {
      type: 'JOB',
      label: i18n('Job'),
      url: orgDashboardCreateJobRoute.with({ orgId }),
    },
  ];

  if (org.canPostVolops) {
    buttons.push({
      type: 'VOLOP',
      label: i18n('Volunteer Opportunity'),
      url: orgDashboardCreateVolopRoute.with({ orgId }),
    });
  }

  buttons.push({
    type: 'INTERNSHIP',
    label: i18n('Internship'),
    url: orgDashboardCreateInternshipRoute.with({ orgId }),
  });

  if (org.canPostEvents) {
    buttons.push({
      type: 'EVENT',
      label: i18n('Event'),
      url: orgDashboardCreateEventRoute.with({ orgId }),
    });
  }

  return buttons;
}
